// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2rRvY","title":"ClientReferral_title__bSqHe","itemText":"ClientReferral_itemText__2VHSV"};